import CreateCandidate from "./Components/CreateCandidate";

export default CreateCandidate;
